import React from 'react';
import Card from '@/components/ui/Card';

interface AuthCardProps extends React.HTMLAttributes<HTMLDivElement> {}

const AuthCard: React.FC<AuthCardProps> = ({ className = '', children, ...rest }) => (
  <Card className={`w-full max-w-md shadow-lg p-8 ${className}`.trim()} {...rest}>
    {children}
  </Card>
);

export default AuthCard; 